import React from 'react';

import { CheckboxProps } from './types';
import {
  CheckboxContainer,
  HiddenCheckbox,
  IconWrapper,
  StyledCheckbox,
} from './styles';

const CustomCheckbox: React.FC<CheckboxProps> = ({
  checked,
  onChange,
  label,
  labelFontSize,
  isError,
}) => {
  return (
    <CheckboxContainer>
      <HiddenCheckbox type="checkbox" checked={checked} onChange={onChange} />
      <StyledCheckbox $checked={checked} $isError={isError}>
        <IconWrapper>
          <svg viewBox="0 0 24 24">
            <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" />
          </svg>
        </IconWrapper>
      </StyledCheckbox>
      {label && (
        <span
          style={{
            fontSize: labelFontSize,
            color: checked ? '#323F4B' : isError ? '#8D0909' : undefined,
          }}
        >
          {label}
        </span>
      )}
    </CheckboxContainer>
  );
};

export default CustomCheckbox;
